import React, {useState} from 'react';
import {map, filter} from 'lodash';
import {useFormikContext} from 'formik';
import classNames from 'classnames';
import Card from 'src/components/Cards/Card';

interface Props {
  counter: number;
  filesDroppedNames: Set<string>;
  filesDropped: Set<File>;
  updateFilesState: (newFilesDropped: Set<File>, newFilesDroppedNames: Set<string>) => void;
}

const FileField = ({counter, filesDroppedNames, filesDropped, updateFilesState}: Props) => {
  const {setFieldValue} = useFormikContext();
  const [dropClassActive, setDropClassActive] = useState(false);
  const dropHandler = async (e) => {
    e.preventDefault();

    const droppedFilesNames = map([...e.dataTransfer.items], (item) => item.getAsFile().name);
    const newFileNamesArray = new Set([...filesDroppedNames, ...droppedFilesNames]);
    const unduplicatedFiles = filter(
      [...e.dataTransfer.items],
      (item) => !filesDroppedNames.has(item.getAsFile().name)
    );
    const droppedFiles = map(unduplicatedFiles, (item) => item.getAsFile());
    const newFilesArray = new Set([...filesDropped, ...droppedFiles]);

    // Use Promise.all to wait for all files to be processed.
    const fileBlobs = await Promise.all(
      droppedFiles.map(
        (file) =>
          new Promise((resolve) => {
            const reader = new FileReader();
            reader.addEventListener('loadend', () => {
              resolve([file.name, reader.result]);
            });
            reader.readAsDataURL(file);
          })
      )
    );

    setFieldValue('addCollegeImages', fileBlobs);

    updateFilesState(newFilesArray, newFileNamesArray);
    setDropClassActive(false);
  };

  const dragOverHandler = (e) => {
    e.preventDefault();
  };

  const dragEnterHandler = () => {
    setDropClassActive(true);
  };

  const dragExitHandler = () => {
    setDropClassActive(false);
  };

  const renderFilesDropped = () =>
    map([...filesDropped], (item) => <Card key={item.name}>{item.name}</Card>);

  const renderCounter = () => {
    if (counter !== 0) {
      return (
        <Card>
          <p>{`Uploading ${counter} out of ${filesDropped.size}`}</p>
        </Card>
      );
    }
    return null;
  };

  return (
    <div className="drop-zone-container">
      <section
        className={classNames('drop-zone', {'drop-zone-active': dropClassActive})}
        role="presentation"
        onDrop={dropHandler}
        onDragOver={dragOverHandler}
        onDragEnter={dragEnterHandler}
        onDragLeave={dragExitHandler}
      >
        <div className="drop-zone-content">
          <p>Drag one or more files to the Drop Zone ...</p>
        </div>
      </section>
      {renderFilesDropped()}
      {renderCounter()}
    </div>
  );
};

export default FileField;
